import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "children", "component", "onClick", "className"];
import React from 'react';
import styled from 'styled-components';
import { COLORS, FONTS, SIZES } from '../styleVars';
import { Image } from '../image/Image';
var Chips = styled.div.withConfig({
  componentId: "sc-1kod8y1-0"
})(["display:flex;flex:1 100%;flex-flow:wrap;"]);
var ChipWrapper = styled.span.withConfig({
  componentId: "sc-1kod8y1-1"
})(["display:flex;box-sizing:content-box;height:", ";min-width:", ";margin:", ";cursor:pointer;"], SIZES['32'], SIZES['72'], SIZES['4']);
var DefaultChip = styled.span.withConfig({
  componentId: "sc-1kod8y1-2"
})(["&&&{height:inherit;display:inline-flex;border-radius:", ";min-width:", ";transition:all 0.1s ease-in-out;background-color:", ";border:", ";color:", ";}"], SIZES['16'], SIZES['72'], function (props) {
  return props.active ? COLORS.fupaSecondary : 'transparent';
}, function (props) {
  return props.active ? "".concat(SIZES['1'], " solid ").concat(COLORS.fupaSecondary) : "".concat(SIZES['1'], " solid ").concat(COLORS.lightGrey);
}, function (props) {
  return props.active ? COLORS.white : COLORS.black;
});
var ChipLabel = styled.span.withConfig({
  componentId: "sc-1kod8y1-3"
})(["display:flex;line-height:", ";font-size:", ";padding:", " ", ";color:inherit;"], SIZES['18'], FONTS['14'], SIZES['8'], SIZES['12']);
var ChipIconContainer = styled.div.withConfig({
  componentId: "sc-1kod8y1-4"
})(["margin:", " -", " ", " ", ";display:inline-flex;justify-content:center;height:", ";width:", ";background-color:", ";border-radius:50%;"], SIZES['1'], SIZES['6'], SIZES['1'], SIZES['1'], SIZES['30'], SIZES['30'], COLORS.white);
var ChipImage = styled(Image).withConfig({
  componentId: "sc-1kod8y1-5"
})(["margin-right:-", ";"], SIZES['8']);

var Chip = function Chip(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'span' : _ref$component,
      onClick = _ref.onClick,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ChipWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(DefaultChip, _extends({
    as: component,
    active: active,
    onClick: onClick
  }, props), children));
};

export { Chips, Chip, ChipLabel, ChipIconContainer, ChipImage };
//# sourceMappingURL=Chip.js.map